export { default } from './SectionHeader'

export { HEADING_TYPE, ALIGN } from './SectionHeader.const'
